import { rootDomainRefreshPage, rootDomainSignOutPage } from '../config/index'
import { removeToken } from './token'
import qs from 'qs'
import { getLoginPath } from '../../../utils'
import { LOGIN_TYPES } from '../../../constants'
import { openLink } from '@/utils'
import { removeLocalLoginType } from '../../../core/loginType'

/**
 * 跳转去登录
 */
export const toLogin = () => {
  removeLocalLoginType()
  location.href = getLoginPath()
}

/**
 * 实际的登录方式
 * 需要在login.vue页面内部调用
 */
export const loginToLogin = () => {
  const query = qs.parse(window.location.href.split('?')[1])
  const origin = window.location.origin
  const redirect = decodeURIComponent(query.redirect || '/')
  if (!import.meta.env.PROD) {
    return alert(
      '开发请登录 [proxy].alphalawyer.cn 后手动复制localStorage中的「token」放置到当前域名localStorage的「_token」（下划线 + token）下进行登录，本次401不跳转'
    )
  }
  let alphaRedirect = (/^https?:\/\//).test(redirect) ? redirect : (origin + redirect)
  const readirectOrigin = alphaRedirect.split('?')[0]
  const readirectQuery = qs.parse(alphaRedirect.split('?')[1] || '')
  delete readirectQuery.loginType
  alphaRedirect = readirectOrigin + '?' + [qs.stringify(readirectQuery), 'loginType=' + LOGIN_TYPES.ALPHA].filter(e => e).join('&')
  console.log('toAlphaRedirect', alphaRedirect)
  openLink(rootDomainRefreshPage + encodeURIComponent(alphaRedirect), true, true)
  // location.href = rootDomainRefreshPage + encodeURIComponent(alphaRedirect)
}

/**
 * 跳转去退出登录
 */
export function toSignOut() {
  removeToken()
  toLogin()
}